export const IMAGES = {
  // Lion cub photos
  CUB_1: '/images/cute_baby_lion_cub_illustration_1.jpeg',
  CUB_2: '/images/cute_baby_lion_cub_illustration_2.jpeg',
  CUB_3: '/images/cute_baby_lion_cub_illustration_3.jpeg',
  CUB_4: '/images/cute_baby_lion_cub_illustration_4.jpeg',
  CUB_5: '/images/cute_baby_lion_cub_illustration_5.jpeg',
  CUB_6: '/images/cute_baby_lion_cub_illustration_6.jpeg',
  CUB_7: '/images/cute_baby_lion_cub_illustration_7.jpeg',
  CUB_8: '/images/cute_baby_lion_cub_illustration_8.jpeg',
  CUB_9: '/images/cute_baby_lion_cub_illustration_9.jpeg',
  CUB_10: '/images/cute_baby_lion_cub_illustration_10.jpeg',
  // Savanna / Africa
  SAVANNA_1: '/images/lion_cub_savanna_golden_sunset_africa_1.jpeg',
  SAVANNA_2: '/images/lion_cub_savanna_golden_sunset_africa_2.jpeg',
  SAVANNA_3: '/images/lion_cub_savanna_golden_sunset_africa_3.jpeg',
  SAVANNA_4: '/images/lion_cub_savanna_golden_sunset_africa_4.jpeg',
  SAVANNA_5: '/images/lion_cub_savanna_golden_sunset_africa_5.jpeg',
  SAVANNA_6: '/images/lion_cub_savanna_golden_sunset_africa_6.jpeg',
  SAVANNA_7: '/images/lion_cub_savanna_golden_sunset_africa_7.jpeg',
  SAVANNA_8: '/images/lion_cub_savanna_golden_sunset_africa_8.jpeg',
  SAVANNA_9: '/images/lion_cub_savanna_golden_sunset_africa_9.jpeg',
} as const;
